






















































import { computed, defineComponent, onBeforeUnmount, ref, watch } from '@vue/composition-api';
// @ts-ignore
import { PopupManager } from 'zk-ui';
import { useLocale } from '../hooks/useLocale';
import ChatList from './ChatList.vue';
import ChatInput from './ChatInput.vue';
import AutomationModule from './module-card/Automation.vue';
import { useAsideComponent } from '../hooks/useAsideComponent';
import { useRender } from '../hooks/useRender';
import { useEventListener, useElementSize, useWindowSize } from '@vueuse/core';
import { isOverseasVersion } from 'common-module/src/util';
import { getStyle } from '@zk/framework-vue';

export default defineComponent({
  components: {
    ChatList,
    ChatInput,
    AutomationModule
  },
  setup() {
    const wrapper = ref<HTMLElement>();
    const { t } = useLocale();
    const { closeRobotChat, closeAside, isShowAside, asideComponent } = useRender();
    // 左侧一级导航元素
    const leftAsideElement = document.querySelector('.zk-left-aside') as HTMLElement;
    const { width } = useElementSize(leftAsideElement);
    const zIndex = PopupManager.nextZIndex();
    const { height } = useWindowSize();
    const wrapHeightValue = ref('auto');
    const wrapHeight = () => {
      const h = getStyle(leftAsideElement, 'height');
      wrapHeightValue.value = h === 'auto' ? `${getStyle(document.body, 'height')}` : h;
    };

    watch(height, () => wrapHeight());

    const wrapStyle = computed<Record<string, string | number>>(() => {
      return {
        '--height': wrapHeightValue.value,
        '--width': `calc(100% - ${width.value}px)`,
        '--leftPosition': `${width.value}px`,
        'z-index': zIndex
      };
    });
    const showTitle = computed(() => isOverseasVersion && leftAsideElement && width.value <= 0);
    // 如果有左侧一级导航，则需要提高它的层级在当前之上
    if (leftAsideElement) {
      leftAsideElement.style.zIndex = zIndex + 1;
    }

    onBeforeUnmount(() => {
      // 重置一级导航层级
      if (leftAsideElement) {
        leftAsideElement.style.zIndex = 'auto';
      }
    });

    // 点击其他地方是否关闭当前
    useEventListener(document, 'mousedown', (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // 如果点击的是当前元素内的 || 打开按钮，都不进行关闭
      if (!wrapper.value || wrapper.value.contains(target) || target.closest('.zk-robot-chat-button')) {
        return;
      }
      // 如果点击的展开收起菜单按钮，则不关闭
      if (target.closest('.zk-aside-toggle')) {
        return;
      }
      // 如果点击是海外新手指引列表关闭按钮，则不关闭
      if (target.closest('.zk-overseas-guide-task-center__close-icon')) {
        return;
      }
      if (target.closest('.zk-left-aside')) {
        onClose();
        return;
      }
    });
    const onClose = () => {
      closeRobotChat(true);
    };


    const {
      setAsideStatus,
      showAsideStatus,
      currentComponent
    } = useAsideComponent();

    const show = computed(() => showAsideStatus.value);
    const current = computed(() => currentComponent.value);
    const handleClose = () => {
      setAsideStatus(false);
    };
    const handleOpen = () => {
      setAsideStatus(true);
    };
    const handleStatusChanged = (v: boolean) => {
      setAsideStatus(v);
    };
    return {
      t,
      wrapper,
      wrapStyle,
      onClose,
      current,
      show,
      handleClose,
      handleStatusChanged,
      handleOpen,
      asideComponent,
      isShowAside,
      showTitle,
      closeAside,
      wrapHeight
    };
  }
});
